import React, { memo } from 'react';
import { XCircle, AlertTriangle, CheckCircle2 } from 'lucide-react';
import { Button } from './ui';
export const SalesLetter = () => {
  return <section className="py-10 md:py-20 px-4 bg-white" data-id="element-175">
      <div className="max-w-[800px] mx-auto font-inter text-lg text-gray-700 space-y-5 md:space-y-8" data-id="element-176">
        <p className="font-nunito font-bold text-2xl text-brand-teal" data-id="element-177">
          Querida Mamá Agotada y Valiente,
        </p>

        <p className="font-semibold text-xl" data-id="element-178">¿Alguna vez sentiste esto?</p>

        <div className="bg-red-50 border-l-4 border-brand-red p-4 md:p-8 rounded-r-xl space-y-4 my-5 shadow-sm" data-id="element-179">
          <ul className="space-y-4" data-id="element-180">
            <li className="flex items-start gap-3" data-id="element-181">
              <XCircle className="w-5 h-5 text-brand-red flex-shrink-0 mt-0.5" data-id="element-182" />
              <p data-id="element-183">
                <strong data-id="element-184">Mirás a tu hijo llorar y retorcerse</strong> y sentís
                que <em data-id="element-185">no podés hacer NADA</em> para ayudarlo.
              </p>
            </li>
            <li className="flex items-start gap-3" data-id="element-186">
              <XCircle className="w-5 h-5 text-brand-red flex-shrink-0 mt-0.5" data-id="element-187" />
              <p data-id="element-188">
                <strong data-id="element-189">
                  Probaste fibra, ciruela, agua, laxantes, supositórios...
                </strong>{' '}
                y nada funciona de verdad o{' '}
                <span className="underline decoration-brand-red/40 decoration-2 underline-offset-2" data-id="element-190">
                  a los días vuelve lo mismo
                </span>
                .
              </p>
            </li>
            <li className="flex items-start gap-3" data-id="element-191">
              <XCircle className="w-5 h-5 text-brand-red flex-shrink-0 mt-0.5" data-id="element-192" />
              <p data-id="element-193">
                <strong data-id="element-194">Sentís la presión de la familia</strong> (y de la
                sociedad) porque tu hijo "ya está grande para el pañal" y{' '}
                <em data-id="element-195">te juzgan como si fuera tu culpa</em>.
              </p>
            </li>
            <li className="flex items-start gap-3" data-id="element-196">
              <XCircle className="w-5 h-5 text-brand-red flex-shrink-0 mt-0.5" data-id="element-197" />
              <p data-id="element-198">
                <strong data-id="element-199">Cada noche se convierte en una negociación</strong>, un
                llanto, un drama que{' '}
                <em data-id="element-200">agota al niño y te rompe el corazón a vos</em>.
              </p>
            </li>
            <li className="flex items-start gap-3" data-id="element-201">
              <XCircle className="w-5 h-5 text-brand-red flex-shrink-0 mt-0.5" data-id="element-202" />
              <p data-id="element-203">
                <strong data-id="element-204">Tenés miedo</strong> —un miedo real y profundo— de que
                esto deje una{' '}
                <span className="underline decoration-brand-red/40 decoration-2 underline-offset-2" data-id="element-205">
                  marca emocional permanente
                </span>{' '}
                en tu hijo.
              </p>
            </li>
          </ul>
        </div>

        <p className="text-xl leading-relaxed" data-id="element-206">
          Esos son los <strong data-id="element-207">mismos miedos y frustraciones</strong> que
          cientos de mamás me contaron desde que empecé a acompañarlas en este
          camino.
        </p>

        <div className="text-center py-5" data-id="element-208">
          <h3 className="font-nunito font-extrabold text-2xl md:text-3xl text-brand-charcoal leading-tight" data-id="element-209">
            "¡La constipación infantil{' '}
            <span className="text-brand-coral underline decoration-brand-coral/30" data-id="element-210">
              no debería robarle la paz
            </span>{' '}
            a ninguna familia!"
          </h3>
        </div>

        <p className="text-xl" data-id="element-211">
          Si querés <strong data-id="element-212">terminar de una vez con esta batalla</strong>...
        </p>

        {/* Agitation Section Moved Up */}
        <div className="text-center py-6 mt-4" data-id="element-213">
          <div className="inline-flex items-center justify-center w-14 h-14 md:w-20 md:h-20 bg-brand-coral/10 rounded-full mb-4" data-id="element-214">
            <AlertTriangle className="w-7 h-7 md:w-10 md:h-10 text-brand-coral" data-id="element-215" />
          </div>
          <h2 className="font-nunito font-extrabold text-3xl md:text-4xl text-brand-charcoal mb-8" data-id="element-216">
            "El Gran Problema Que Nadie Te Está Contando..."
          </h2>
        </div>

        <div className="space-y-6 text-xl" data-id="element-217">
          <p data-id="element-218">
            La mayoría de los "consejos" sobre constipación infantil son{' '}
            <strong data-id="element-219">UN FRACASO ANUNCIADO.</strong>
          </p>
          <p data-id="element-220">¿Por qué?</p>
          <div className="bg-red-50 p-6 rounded-xl border border-red-100" data-id="element-221">
            <p data-id="element-222">
              Porque atacan el síntoma (la panza llena) y{' '}
              <span className="underline decoration-brand-red/40 decoration-2 underline-offset-2 font-semibold" data-id="element-223">
                JAMÁS tocan la raíz real del problema
              </span>
              .
            </p>
          </div>
        </div>

        <h4 className="font-nunito font-bold text-2xl mt-8 mb-5 text-brand-charcoal" data-id="element-224">
          Lo que seguramente ya probaste — y por qué NO funciona:
        </h4>

        <div className="space-y-4 mb-6" data-id="element-225">
          <div className="flex items-start gap-3 bg-white p-4 md:p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-226">
            <div className="bg-red-100 p-2 rounded-full flex-shrink-0" data-id="element-227">
              <XCircle className="w-6 h-6 text-brand-red" data-id="element-228" />
            </div>
            <div data-id="element-229">
              <p className="font-bold text-xl text-brand-charcoal mb-2" data-id="element-230">
                Los laxantes y supositorios:
              </p>
              <p className="text-gray-600" data-id="element-231">
                Alivio temporal, pero el ciclo vuelve.{' '}
                <em data-id="element-232">
                  El cuerpo se acostumbra y el niño aprende que ir al baño
                  duele.
                </em>
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 bg-white p-4 md:p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-233">
            <div className="bg-red-100 p-2 rounded-full flex-shrink-0" data-id="element-234">
              <XCircle className="w-6 h-6 text-brand-red" data-id="element-235" />
            </div>
            <div data-id="element-236">
              <p className="font-bold text-xl text-brand-charcoal mb-2" data-id="element-237">
                La "solución" de la fibra y la dieta:
              </p>
              <p className="text-gray-600" data-id="element-238">
                No es un problema de lo que come. Es un problema del{' '}
                <strong data-id="element-239">MIEDO</strong> que ya instaló en su cuerpo.
              </p>
            </div>
          </div>

          <div className="flex items-start gap-3 bg-white p-4 md:p-6 rounded-2xl shadow-sm border border-gray-100" data-id="element-240">
            <div className="bg-red-100 p-2 rounded-full flex-shrink-0" data-id="element-241">
              <XCircle className="w-6 h-6 text-brand-red" data-id="element-242" />
            </div>
            <div data-id="element-243">
              <p className="font-bold text-xl text-brand-charcoal mb-2" data-id="element-244">
                Obligarlo a dejar el pañal "de prepo" porque ya tiene 3, 4 o 5
                años:
              </p>
              <p className="text-gray-600" data-id="element-245">
                Le generás{' '}
                <strong data-id="element-246">más ansiedad, más retención, más dolor</strong>.
              </p>
            </div>
          </div>
        </div>

        {/* NEW Consequences Box */}
        <div className="bg-orange-50 border-l-4 border-brand-gold p-4 md:p-8 rounded-r-xl space-y-3 my-6 md:my-12 shadow-sm" data-id="element-247">
          <h4 className="font-nunito font-bold text-2xl text-brand-charcoal mb-3 flex items-center gap-2" data-id="element-248">
            <AlertTriangle className="w-6 h-6 text-brand-gold" data-id="element-249" />
            ¿Qué pasa si no lo resolvemos ahora?
          </h4>
          <ul className="space-y-4 text-lg" data-id="element-250">
            <li className="flex items-start gap-3" data-id="element-251">
              <span className="text-brand-gold font-bold mt-0.5" data-id="element-252">•</span>
              <p data-id="element-253">
                <strong data-id="element-254">El dolor físico empeora:</strong> La retención
                prolongada agranda el intestino, haciendo que cada vez sea más
                difícil y doloroso evacuar.
              </p>
            </li>
            <li className="flex items-start gap-3" data-id="element-255">
              <span className="text-brand-gold font-bold mt-0.5" data-id="element-256">•</span>
              <p data-id="element-257">
                <strong data-id="element-258">El trauma emocional se profundiza:</strong> El baño se
                asocia cada vez más con castigo, miedo y ansiedad extrema.
              </p>
            </li>
            <li className="flex items-start gap-3" data-id="element-259">
              <span className="text-brand-gold font-bold mt-0.5" data-id="element-260">•</span>
              <p data-id="element-261">
                <strong data-id="element-262">El estrés familiar no termina:</strong> Las noches
                siguen siendo una batalla, afectando la relación con tu hijo y
                tu propia salud mental.
              </p>
            </li>
          </ul>
        </div>

        {/* Authority Section */}
        <div className="my-8 md:my-16 bg-brand-cream p-5 md:p-10 rounded-3xl shadow-sm border border-brand-teal/10 space-y-4" data-id="element-263">
          <div className="flex flex-col md:flex-row md:items-start gap-6" data-id="element-264">
            <div className="flex-1" data-id="element-265">
              <h3 className="font-nunito font-bold text-3xl text-brand-teal mb-4" data-id="element-266">
                Quién soy...
              </h3>
              <p className="text-lg" data-id="element-267">
                Soy{' '}
                <strong data-id="element-268">
                  médica pediatra, neonatóloga y terapista infantil
                </strong>
                , y hace años acompaño a familias en el cuidado de sus hijos.
              </p>
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/66gNtV9Tkx3HMUW71nqC65/1_800x800.webp" alt="Médica pediatra y neonatóloga" className="w-24 h-24 md:w-36 md:h-36 rounded-2xl object-cover shadow-md border-2 border-white flex-shrink-0 mx-auto md:mx-0" data-id="element-269" />
          </div>
          <p className="text-lg" data-id="element-270">
            En la práctica veo con mucha frecuencia{' '}
            <em data-id="element-271">niños con constipación y padres angustiados</em>, sin saber cómo
            ayudarlos o recibiendo información confusa.
          </p>
          <div className="bg-white p-4 md:p-6 rounded-xl border-l-4 border-brand-coral shadow-sm my-4" data-id="element-272">
            <p className="text-lg" data-id="element-273">
              La constipación <strong data-id="element-274">no es solo una molestia</strong>: puede
              generar{' '}
              <span className="underline decoration-brand-coral/30 decoration-2 underline-offset-2" data-id="element-275">
                dolor, rechazo al baño y afectar el bienestar de toda la familia
              </span>
              .
            </p>
          </div>
          <p className="text-lg" data-id="element-276">
            Por eso creé esta guía: un <strong data-id="element-277">paso a paso claro</strong>,
            basado en mi experiencia real, para que entiendas{' '}
            <em data-id="element-278">qué le pasa a tu hijo</em> y{' '}
            <strong data-id="element-279">cómo ayudarlo de forma efectiva</strong>.
          </p>
          <p className="font-bold text-xl text-brand-charcoal text-center mt-5 pt-5 border-t border-brand-teal/10" data-id="element-280">
            Si estás pasando por esto, <em data-id="element-281">no estás sola</em>. Y sí,{' '}
            <strong data-id="element-282">se puede mejorar</strong>.
          </p>
        </div>

        {/* Teal Box */}
        <div className="bg-brand-teal text-white p-5 md:p-12 rounded-3xl shadow-xl mt-8 md:mt-16 relative overflow-hidden" data-id="element-283">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white opacity-5 rounded-full -mr-20 -mt-20" data-id="element-284"></div>

          <h3 className="font-nunito font-bold text-3xl mb-5 relative z-10 leading-tight" data-id="element-285">
            La verdad que muy pocos profesionales te cuentan en un consultorio
            de 15 minutos es esta:
          </h3>

          <div className="space-y-4 text-xl relative z-10 mb-10" data-id="element-286">
            <p data-id="element-287">
              Tu hijo desarrolló una <strong data-id="element-288">"memoria de dolor"</strong>.
            </p>
            <p data-id="element-289">
              Su cerebro aprendió que <em data-id="element-290">ir al baño duele</em>. Entonces
              retiene.
            </p>
            <p data-id="element-291">
              Al retener, se acumula más, y duele más.{' '}
              <span className="underline decoration-white/40 decoration-2 underline-offset-4" data-id="element-292">
                Y el ciclo se repite.
              </span>
            </p>
          </div>

          <div className="bg-white/10 p-5 md:p-8 rounded-2xl border border-white/20 relative z-10 backdrop-blur-sm" data-id="element-293">
            <p className="font-black text-2xl flex items-center gap-3 mb-3" data-id="element-294">
              <CheckCircle2 className="w-8 h-8 text-brand-cream" data-id="element-295" />
              No es capricho. No es malcrianza.
            </p>
            <div className="space-y-4 text-lg text-teal-50" data-id="element-296">
              <p data-id="element-297">
                Es <em data-id="element-298">neurobiología básica</em> del desarrollo infantil.
              </p>
              <p data-id="element-299">Y tiene solución.</p>
              <p className="font-bold text-xl text-white" data-id="element-300">
                Pero no con más fibra.
              </p>
            </div>
          </div>
        </div>

        {/* MidPage CTA Transition */}
        <div className="text-center py-8 px-4 md:py-12 md:px-6 bg-gray-50 rounded-3xl mt-8 md:mt-16 border border-gray-100 shadow-sm" data-id="element-301">
          <h3 className="font-nunito font-bold text-2xl md:text-3xl text-brand-charcoal mb-3" data-id="element-302">
            Existe una solución. Y está al alcance de tu mano.
          </h3>
          <p className="text-lg text-gray-600 mb-5 font-medium" data-id="element-303">
            Creada por una pediatra, probada por cientos de mamás.
          </p>
          <Button className="text-xl py-4 px-8 md:py-5 md:px-10" data-id="element-304">
            Quiero Ver La Solución →
          </Button>
        </div>
      </div>
    </section>;
};